import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import BillsAccountsCell from './BillsAccountsCell';

const ItemAccountsRow = ({ keyName, data }) => {
  //console.log(JSON.stringify(data));

  if (!keyName && !data) {
    return null;
  }

  return (
    data &&
    data.map((item, iIndex) => {
      let key = item.id + iIndex;

      return (
        <TableRow key={key}>
          <TableCell sx={{ width: 80, textAlign: 'center' }}>
            {item.id}
          </TableCell>
          <TableCell>{item.itemNm}</TableCell>
          <BillsAccountsCell data={item[keyName]} />
        </TableRow>
      );
    })
  );
};

export default ItemAccountsRow;
